import { render, staticRenderFns } from "./ExerciseBookDetail.vue?vue&type=template&id=449f1da6"
import script from "./ExerciseBookDetail.vue?vue&type=script&lang=js"
export * from "./ExerciseBookDetail.vue?vue&type=script&lang=js"
import style0 from "./ExerciseBookDetail.vue?vue&type=style&index=0&id=449f1da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports